import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ color }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;

    p {
      font-weight: 400;
      font-size: 1.2rem;

      color: ${color};

      strong {
        margin-right: 0.5rem;
      }
    }
  `}
`;

const whrapperheaderModifiers = {
  colors: (dir = 'E', groud = 'O', color = '#666') => css`
    border-color: ${groud === dir || groud === 'A' ? color : '#666'};
    color: ${groud === dir || groud === 'A' ? color : '#666'};

    span {
      background-color: ${groud === dir || groud === 'A' ? color : '#fff'};

      svg {
        color: ${groud === dir || groud === 'A' ? '#fff' : '#666'};
      }
    }
  `,
  spanColors: (color) => css`
    background-color: ${color};

    svg {
      color: white;
    }
  `,
};

export const WrapperHeader = styled.header`
  ${({ align, color, ground }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;

    > svg {
      width: 6rem;
      height: 6rem;

      color: ${color};

      margin-bottom: 1rem;
    }

    span {
      border-width: 0.1rem;
      border-style: solid;
      border-radius: 50%;

      ${color !== '#666' && whrapperheaderModifiers.spanColors(color)}

      display: flex;
      align-items: center;
      justify-content: center;

      padding: 0.5rem;

      svg {
        font-size: 1.5rem;
      }
    }

    ${whrapperheaderModifiers.colors(align, ground, color)}
  `}
`;

export const SpanProgramming = styled.span`
  display: block;
`;

export const ProgressBar = styled.div`
  ${({ full, filled, color }) => css`
    width: 100%;
    height: 2rem;

    max-width: 100%;

    border-width: 0.1rem;
    border-style: solid;
    border-color: ${color};

    position: relative;

    user-select: none;

    margin-bottom: 0.5rem;

    &:before {
      content: '';

      position: absolute;

      top: 0;
      left: 0;

      width: ${((filled * 100) / full).toFixed(2)}%;
      height: calc(2rem - 0.2rem);

      max-width: 100%;

      z-index: 9;

      background-color: ${color};
    }

    p {
      position: absolute;

      top: 50%;
      left: 50%;

      transform: translate(-50%, -50%);

      z-index: 10;

      font-weight: 500;
      font-size: 1rem;

      color: #333;
    }

    + p {
      margin-bottom: 1rem;
    }
  `}
`;

export const WrapperGroup = styled.div`
  ${({ align }) => css`
    display: flex;
    justify-content: space-between;
    flex-direction: ${align === 'E' ? 'row' : 'row-reverse'};

    margin-bottom: 0.5rem;

    .text {
      display: flex;
      flex-direction: column;
      flex: 1;

      margin-left: ${align === 'E' ? '1rem' : '0'};
      margin-right: ${align === 'E' ? '0' : '1rem'};

      p {
        width: 100%;

        font-weight: 700;

        display: flex;
        justify-content: space-between;

        strong {
          flex: 1;
          font-weight: 400;
        }
      }
    }
  `}
`;
